import React, {Fragment, useContext, useState} from 'react';
import {Card, CardBody, CardHeader, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import {H5, H4, H6, P, Image, Btn} from '../../../../AbstractElements';
import CustomizerContext from '../../../../_helper/Customizer';
import ManageAPK from "../../../../api/ManageAPK";
import {toast} from "react-toastify";

const AddApk = ({reloadAction}) => {
    const {layoutURL} = useContext(CustomizerContext);

    const [apkName, setApkName] = useState('');
    const [apkFile, setApkFile] = useState(null);

    const handleApkNameChange = (e) => setApkName(e.target.value);
    const handleFileChange = (e) => setApkFile(e.target.files[0]);

    const uploadAPK = async (e) => {
        e.preventDefault();

        if (!apkFile) {
            toast.error('Veuillez sélectionner un fichier APK.');
            return;
        }

        const formData = new FormData();
        formData.append('apk_name', apkName);
        formData.append('apk_file', apkFile);

        try {

            console.log(formData);
            const response = await ManageAPK.addApk(formData);
            console.log(response.data.response.status_code)
            if ((response.data.response.status_code === 200) || (response.data.response.status_code === 201)) {
                setApkName("")
                setApkFile(null)
                reloadAction();
            }

            toast.success('Fichier APK uploadé avec succès');
        } catch (error) {
            toast.error('Erreur lors de l\'upload');
        }
    };

    return (
        <Fragment>
            <Card>
                <CardHeader>
                    <H4 attrH4={{className: 'card-title mb-0'}}>Uploader un apk</H4>
                    <div className='card-options'>
                        <a className='card-options-collapse' href='#javascript'>
                            <i className='fe fe-chevron-up'></i>
                        </a>
                        <a className='card-options-remove' href='#javascript'>
                            <i className='fe fe-x'></i>
                        </a>
                    </div>
                </CardHeader>
                <CardBody>
                    <Form onSubmit={uploadAPK} encType="multipart/form-data">
                        <FormGroup className='mb-3'>
                            <Label className='form-label'>Nom de l'apk</Label>
                            <Input
                                className='form-control'
                                type='text'
                                placeholder="Nom de l'apk"
                                value={apkName}
                                onChange={handleApkNameChange}
                            />
                        </FormGroup>
                        <FormGroup className='mb-3'>
                            <Label className='form-label'>Fichier APK</Label>
                            <Input
                                className='form-control'
                                type='file'
                                accept='.apk'
                                onChange={handleFileChange}
                            />
                        </FormGroup>
                        <div className='form-footer'>
                            <Btn attrBtn={{className: 'btn-block', color: 'primary'}}>
                                Enregistrer
                            </Btn>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    );
};
export default AddApk;
